import React from 'react';
import { useCart } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';

const Cart = () => {
    const { cartItems, removeFromCart, increaseQuantity, decreaseQuantity } = useCart();
    const navigate = useNavigate();

    const total = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);

    return (
        <div className="max-w-3xl mx-auto p-4 mt-8 bg-white rounded-xl shadow">
            <h2 className="text-xl font-bold mb-6 flex items-center gap-2">🛒 Your Cart</h2>
            {cartItems.length === 0 ? (
                <div className="text-center text-gray-500">
                    <p>Your cart is empty.</p>
                    <button
                        onClick={() => navigate('/')}
                        className="mt-4 bg-orange-400 text-white px-6 py-2 rounded hover:bg-orange-500 transition"
                    >
                        Shop Products
                    </button>
                </div>
            ) : (
                <>
                    <div className="divide-y">
                        {cartItems.map((item) => {
                            console.log('🛒 Cart item:', item);
                            return (
                            <div key={item.id} className="flex items-center py-4">
                                <img
                                    src={item.thumbnail || '/images/box.png'}
                                    alt={item.name}
                                    className="w-16 h-16 rounded object-contain border"
                                />
                                <div className="ml-4 flex-1">
                                    <div className="font-semibold">{item.name}</div>
                                    <div className="text-gray-700 text-sm">
                                        ₹{item.price} × {item.quantity}
                                    </div>
                                    <div className="flex items-center mt-1">
                                        <button onClick={() => decreaseQuantity(item.id)} className="px-2 py-1 bg-gray-200 rounded text-lg">-</button>
                                        <span className="mx-3">{item.quantity}</span>
                                        <button onClick={() => increaseQuantity(item.id)} className="px-2 py-1 bg-gray-200 rounded text-lg">+</button>
                                        <button
                                            onClick={() => removeFromCart(item.id)}
                                            className="ml-6 text-red-600 hover:underline"
                                        >
                                            Remove
                                        </button>
                                    </div>
                                </div>
                                <div className="text-right font-bold w-24">
                                    ₹{item.price * item.quantity}
                                </div>
                            </div>
                            );
                        })}
                    </div>
                    <div className="flex justify-between items-center mt-8">
                        <div className="text-lg font-semibold">Total:</div>
                        <div className="text-2xl font-bold">₹{total}</div>
                    </div>
                    <div className="flex justify-end mt-6">
                        <button
                            onClick={() => navigate('/checkout')}
                            className="bg-green-600 text-white px-8 py-2 rounded hover:bg-green-700 transition"
                        >
                            Proceed to Checkout
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default Cart;
